import React, { useContext } from 'react';
import { Button, IconButton, Typography, Box, Paper, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { decrypt } from '../../Security';
import { AuthContext } from '../Auth/AuthContext';
import PersonIcon from '@mui/icons-material/Person';
import DownloadIcon from '@mui/icons-material/Download';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

const Logout = ({ isAdmin }) => {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(AuthContext);

  const jsonToCSV = (json) => {
    const headers = Object.keys(json[0]);
    const csvRows = [headers.join(',')];
    json.forEach(row => {
      const values = headers.map(header => `"${('' + row[header]).replace(/"/g, '""')}"`);
      csvRows.push(values.join(','));
    });
    return csvRows.join('\n');
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.hidden = true;
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

const moveDataFromPendingToRepresentative = async () => {
  try {
    const response = await fetch(
      process.env.REACT_APP_PUBLIC_SERVER_URI + '/adminWeb/moveDataFromPendingToRepresentative',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }
    );

    const data = decrypt(await response.json());

    if (data.msg === 'Data move completed') {
      alert(`Moved successfully: ${data.successCount}, Errors: ${data.errorCount}`);
    } else {
      alert('Unable to move data, please try again!');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Something went wrong!');
  }
};

  
    const downloadData=async()=>{
  
      try {
        const response = await fetch(process.env.REACT_APP_PUBLIC_SERVER_URI + '/adminWeb/downloadData', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          } 
          ,credentials:'include'
        });
    
        const data = decrypt(await response.json());
  
        // Handle new backend response format
        if (data.csv && data.csv.trim() !== '') {
          // Backend now returns pre-formatted CSV
          downloadCSV(data.csv, 'representatives_data.csv');
          alert(`Successfully downloaded ${data.count || 0} records`);
        } else if (data.reps && data.reps.length > 0) {
          // Fallback for old format (if backend reverts)
          const csvData = jsonToCSV(data.reps);
          downloadCSV(csvData, 'representatives_data.csv');
        } else { 
          alert(data.msg || 'No data available to download');
        }
      } catch (error) {
        console.error('Download Error:', error);
        alert('Unable to download data. Please try again later.');
      }
  
    }

  const handleLogout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_PUBLIC_SERVER_URI}/api/v1/auth/logout`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
      if (response.ok) {
        setIsAuthenticated(false);
        navigate('/admin');
      } else {
        alert('Unable to logout. Please try again!');
      }
    } catch (error) {
      console.error('Logout error:', error);
      alert('Error during logout. Please try again later.');
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {isAdmin && (
        <Tooltip title="Download Representatives Data" arrow>
          <IconButton
            onClick={downloadData}
            size="small"
            sx={{ color: 'rgba(255,255,255,0.75)', '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.1)' } }}
          >
            <DownloadIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Logout" arrow>
        <IconButton
          onClick={handleLogout}
          size="small"
          sx={{ color: 'rgba(255,255,255,0.75)', '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.1)' } }}
        >
          <PowerSettingsNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Logout;
